import styled from 'styled-components';
export const CustomForm = styled.section`
  margin-bottom: 30px;
  padding: 25px;
  background-color: #f8fafb;
  border-radius: 20px;
`;